export function withNaPermissionOverride<
  T extends { id: string; permission?: string[] | string[][] | boolean }
>(continentList: T[], isNaPermitted: boolean): T[] {
  return continentList.map((continent) =>
    continent.id === 'NA'
      ? ({ ...continent, permission: isNaPermitted } as T)
      : continent
  );
}
